// Public price-history rule: show the card only when the latest asking-price
// change is a drop of at least 1% versus the previous price, compared in EUR.
export const PRICE_DROP_MIN_PCT = 1;

export interface PricePoint {
  changed_at: string;
  price: number;
  currency: string | null;
  price_eur: number | null;
}

/** Points must be newest first. Returns the drop % (rounded, ≥1) or null. */
export function latestPriceDropPct(points: PricePoint[]): number | null {
  if (!points || points.length < 2) return null;
  const [latest, previous] = points;
  if (latest.price_eur == null || previous.price_eur == null || previous.price_eur <= 0) return null;
  const pct = ((previous.price_eur - latest.price_eur) / previous.price_eur) * 100;
  if (pct < PRICE_DROP_MIN_PCT) return null;
  return Math.round(pct);
}
